import { cn, ia } from 'lib/helpers/utility';

const NotAssignedPlaceHolder = () => (
  <div className="flex h-full w-full items-center">
    <div className="flex h-full max-h-5 w-fit items-center justify-center rounded-md border border-solid border-neutral-200 bg-neutral-100 px-1.5 text-xs text-neutral-900">
      N/A
    </div>
  </div>
);

const StepInfoCell = ({ value, stepDefinition }) => {
  if (!stepDefinition) {
    return <NotAssignedPlaceHolder />;
  }
  const steps = ia(value?.steps) ? value.steps : [];
  if (steps.length === 0) {
    return <NotAssignedPlaceHolder />;
  }
  const stepAssigned = steps.find((s) => s.step_definition_code === stepDefinition);
  if (!stepAssigned) {
    return <NotAssignedPlaceHolder />;
  }
  const isCompleted = stepAssigned?.completed;
  return (
    <div className="flex h-full w-full items-center">
      <div
        className={cn(
          'flex h-full max-h-5 w-fit items-center justify-center rounded-md px-1.5 text-xs text-neutral-900',
          isCompleted
            ? 'border border-solid border-success-200 bg-success-100'
            : 'border border-solid border-danger-200 bg-danger-100'
        )}>
        {isCompleted ? 'Completed' : 'Incomplete'}
      </div>
    </div>
  );
};

export default StepInfoCell;
